import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TVplcOptionInfoProps } from '@/console/features/orchestrators/components/vplc-picker/vplc-picker.types';
import { PROVISIONING_I18N_PREFIX } from '@/console/features/orchestrators/orchestrators.constants';
import { getVplcBinding } from '@/console/features/orchestrators/utils/vplc-binding';
import { Chip } from '@/shared/components/ui/chip/chip';

export const VplcOptionInfo: React.FC<TVplcOptionInfoProps> = ({ vplc }) => {
  const { t } = useTranslation();
  const { state, chipStatus } = getVplcBinding(vplc);

  const address =
    vplc.ipAddress ?? t(`${PROVISIONING_I18N_PREFIX}.binding.no_address`);

  return (
    <Stack direction="row" alignItems="center" gap="0.5rem">
      <Typography variant="p8" color="textSecondary">
        {[address, vplc.runtimeVersion].filter(Boolean).join(' · ')}
      </Typography>
      {state && chipStatus && (
        <Chip
          status={chipStatus}
          label={t(`${PROVISIONING_I18N_PREFIX}.binding.state.${state}`)}
        />
      )}
    </Stack>
  );
};
